import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  API_GET_STATEMENT,
  API_GET_STATEMENT_INVESTMENT,
} from "../../../config/api";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../helper/proccessErrorMessage";

export const getStatementInvestment = createAsyncThunk(
  "getStatementInvestment/Post",
  async ({ data, currency, cb, failed }, { dispatch }) => {
    try {
      const response = await Client({
        method: "GET",
        path: `${API_GET_STATEMENT_INVESTMENT}${currency}&date_from=${data?.date_from}&date_to=${data?.date_to}`,
      });
      cb();

      toast.success(
        "Your investment statement has been forwarded to your email.",
      );
      return response?.data?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);

      failed();
    }
  },
);
